let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l0KDU")).then(() => parcelRequire('bxZ8e'));